module.exports = __webpack_public_path__ + "media/images/prevention_form/partydrogen-16c3f3f2a57b7eb46affef57e34e9808.svg";